import {formatDecimal} from '@/lib/currency/currency.js'
import {getCssColor} from '@/lib/color/index.js'
import capitalize from '../../filters/string/capitalize.js'

export default {
  data() {
    return {}
  },

  methods: {
    getCssColor,
    formatDecimal,

    setCampaignLoading(campaign, event, loading = false) {
      if (!campaign) return
      this.$set(campaign, 'loading', loading)
      if (event) this.$set(campaign, `loading${capitalize(event || '')}`, loading)
    },

    getDataTableCampaign(campaignId) {
      return this.dataTable?.data?.find(campaign => campaign.Id === campaignId)
    },

    getStatus(campaign) {
      const statusExists = this.$te(`Marketing.Campaign.Status.${campaign.Status}`)
      return statusExists ? this.$t(`Marketing.Campaign.Status.${campaign.Status}`) : this.$t(`Marketing.Campaign.Status.UNKNOWN`)
    },

    getTags(campaign) {
      const tags = campaign?.Tag || []
      const retVal = []
      tags.forEach(tagId => {
        const tag = this.tags.find(tag => tag.Id === tagId)
        if (tag) retVal.push(tag)
      })

      return retVal
    },

    getGroups(campaign) {
      const retVal = []

      if (campaign.GroupIncludes.length) {
        const groups = campaign?.GroupIncludes || []
        const groupItems = []
        groups.forEach(groupId => {
          const group = this.customerGroups.find(customerGroup => customerGroup.Id === groupId)
          if (group) groupItems.push(group)
        })

        retVal.push({
          Title: 'INCLUDED GROUPS',
          Type : 'include',
          Color: 'blue darken-2',
          Items: groupItems
        })
      }

      if (campaign.GroupExcludes.length) {
        const groups = campaign?.GroupExcludes || []
        const groupItems = []
        groups.forEach(groupId => {
          const group = this.customerGroups.find(customerGroup => customerGroup.Id === groupId)
          if (group) groupItems.push(group)
        })

        retVal.push({
          Title: 'EXCLUDED GROUPS',
          Type : 'exclude',
          Color: 'orange darken-2',
          Items: groupItems
        })
      }

      if (!campaign.GroupIncludes.length && !campaign.GroupExcludes.length) retVal.push({
        Title: 'ALL GROUPS',
        Type : 'all',
        Color: 'green darken-2',
        Items: []
      })

      return retVal
    }
  },
  watch   : {},
  computed: {},
  mounted() {
  },
  beforeDestroy() {
  }
}
